export default __webpack_public_path__ + "static/sonstige-3deb7aff05aae22e570968eb80c48fbf.jpg";